import React, { Component } from 'react';
import { withFirebase } from '../Firebase';
import { withRouter } from 'react-router-dom';
import PeerLine from '../../components/PeerLine/PeerLine';
import TeamLine from '../../components/TeamLine/TeamLine';
import CardCarousel from '../../components/Card/BasicCardCarousel';
import CreateCapsule from './ButtonCreate';
import LatestPolls from './LatestPolls';
import 'firebase/functions';
import * as firebase from 'firebase';


import "./HomePage.css";
import { Fade } from '@material-ui/core';
import Loading from '../Loading';


const INITIAL_STATE = {
  managerID: '',
  myAssignments: [],
  teamCapsules: [],
  peersCapsules: [],
  snackbarUpDownOpen: false,
  currentCapsuleId: '',
  action: null,
  needToRemoveIfUndo: false,
  loading: true,
  error: null,
  currentUserInfos: null,
  nbUsers: 0,
};

class HomePage extends Component {

  render() {
    return (
      <HomePageComponent />)
  }
}

class HomePageComponentBase extends Component {

  constructor(props) {
    super(props);
    this.state = { ...INITIAL_STATE };
  }

  componentDidMount() {

    document.body.style.background = '#F8F9FB';

    this.props.firebase.auth.onAuthStateChanged(async (currentUser) => {
      if (currentUser === null) {
        return
      }

      this.refreshUser(currentUser)
    })
  }

  refreshUser = async (currentUser) => {
    let querySnapshotUsers = await this.props.firebase.db.collection('users').get()
    const currentUserInfos = querySnapshotUsers.docs
      .filter(user => user.id === currentUser.uid)
      .map(doc => doc.data())[0]
    if (!currentUserInfos) {
      this.refreshUser(currentUser)
      return
    }

    const myCompany = currentUserInfos.company;
    const nbUsers = querySnapshotUsers.docs.filter(user => user.data().company === myCompany).length

    const managerID = currentUserInfos.manager;
    let querySnapshotAssignments = await this.props.firebase.db.collection('assignments').where('targetUser', '==', currentUser.uid).where('accepted', '==', null).get()
    const myAssignments = querySnapshotAssignments.docs.map(doc => doc.data())
    this.refreshCapsules(currentUser, managerID);
    this.setState({
      myAssignments,
      managerID,
      loading: false,
      currentUserInfos,
    });

    localStorage.setItem('nbUsersCompany', nbUsers);
  }

  refreshCapsules = async (user, managerID) => {
    let querySnapshotCapsulesPeers = await this.props.firebase.db.collection('capsules').where('managers', 'array-contains', managerID).get()
    let querySnapshotCapsulesTeam = await this.props.firebase.db.collection('capsules').where('managers', 'array-contains', user.uid).get()

    let peersCapsules = [];
    let teamCapsules = [];

    for (const capsulePeer of querySnapshotCapsulesPeers.docs) {
      let capsulePeerManagers = capsulePeer.data().managers;
      let assigneeId = capsulePeer.data().assigneeId;

      if (!assigneeId) {

        if (capsulePeerManagers.includes(managerID)) {
          peersCapsules = peersCapsules.concat({
            id: capsulePeer.id,
            ...capsulePeer.data()
          });
        }
      }
    }
    for (const capsuleTeam of querySnapshotCapsulesTeam.docs) {
      let capsuleTeamManagers = capsuleTeam.data().managers;
      let assigneeId = capsuleTeam.data().assigneeId;

      if (!assigneeId) {

        if (capsuleTeamManagers.includes(user.uid)) {
          teamCapsules = teamCapsules.concat({
            id: capsuleTeam.id,
            ...capsuleTeam.data()
          });

        }
      }
    }
    this.setState({ peersCapsules, teamCapsules })
  }

  openSnackbar = () => {
    this.setState({ snackbarUpDownOpen: true });
  };

  closeSnackbar = (event, reason) => {
    const managerID = this.state.managerID
    if (reason === 'clickaway') {
      return;
    }
    this.refreshCapsules(this.props.firebase.auth.currentUser, managerID)
    this.setState({ snackbarUpDownOpen: false, needToRemoveIfUndo: false });
  };

  upCapsule = async (capsuleID) => {
    let querySnapshotCapsule = await this.props.firebase.db.collection('capsules').doc(capsuleID).get()
    let managers = querySnapshotCapsule.data().managers
    const timestamp = Date.now();
    const { currentUserInfos } = this.state
    this.setState({
      currentCapsuleId: capsuleID,
      action: 'up',
      needToRemoveIfUndo: !managers.includes(this.state.managerID)
    })

    await this.props.firebase.db.collection('capsules').doc(capsuleID).update({
      managers: firebase.firestore.FieldValue.arrayUnion(this.state.managerID)
    })

    let newHistoric = { date: timestamp, firstname: currentUserInfos.firstname, lastname: currentUserInfos.lastname, picture: currentUserInfos.image_url_profile, status: "up" }
    await this.props.firebase.db.collection('capsules').doc(capsuleID).collection('historic').add(newHistoric)

    this.openSnackbar();

  }

  downCapsule = async (capsuleID) => {
    let querySnapshotCapsule = await this.props.firebase.db.collection('capsules').doc(capsuleID).get()
    let managers = querySnapshotCapsule.data().managers
    const timestamp = Date.now();
    const { currentUserInfos } = this.state
    this.setState({
      currentCapsuleId: capsuleID,
      action: 'down',
      needToRemoveIfUndo: !managers.includes(this.props.firebase.auth.currentUser.uid)
    })
    await this.props.firebase.db.collection('capsules').doc(capsuleID).update({
      managers: firebase.firestore.FieldValue.arrayUnion(this.props.firebase.auth.currentUser.uid)
    })
    let newHistoric = { date: timestamp, firstname: currentUserInfos.firstname, lastname: currentUserInfos.lastname, picture: currentUserInfos.image_url_profile, status: "down" }
    await this.props.firebase.db.collection('capsules').doc(capsuleID).collection('historic').add(newHistoric)
    this.openSnackbar();
  }

  undoUpDown = async () => {
    const { action, currentCapsuleId, needToRemoveIfUndo } = this.state
    if (needToRemoveIfUndo) {
      if (action === 'up') {
        await this.props.firebase.db.collection('capsules').doc(currentCapsuleId).update({
          managers: firebase.firestore.FieldValue.arrayRemove(this.state.managerID)
        })
        this.closeSnackbar();
      }
      else {
        const currentCapsuleId = this.state.currentCapsuleId;
        await this.props.firebase.db.collection('capsules').doc(currentCapsuleId).update({
          managers: firebase.firestore.FieldValue.arrayRemove(this.props.firebase.auth.currentUser.uid)
        })
        this.closeSnackbar();
      }
    }
    this.closeSnackbar();
  }

  render() {
    const { loading, currentUserInfos } = this.state

    return (
      <>
        {currentUserInfos ?
          <div>
            <LatestPolls page={'home'} />
            <PeerLine myAssignments={this.state.myAssignments} />
            <Fade in={!loading}>
              <div>
                <CardCarousel data={this.state.peersCapsules}
                  direction={'down'}
                  upCapsule={this.upCapsule}
                  downCapsule={this.downCapsule}
                  undo={this.undoUpDown}
                  snackbarUpDownOpen={this.state.snackbarUpDownOpen}
                  closeSnackbar={this.closeSnackbar}
                  messageSnackBar={this.state.action === 'up' ? "Capsule remontée" : "Capsule descendue"} />
              </div>
            </Fade>
            <TeamLine />
            <Fade in={!loading}>
              <div>
                <CardCarousel data={this.state.teamCapsules}
                  direction={'up'}
                  upCapsule={this.upCapsule}
                  downCapsule={this.downCapsule}
                  undo={this.undoUpDown}
                  snackbarUpDownOpen={this.state.snackbarUpDownOpen}
                  closeSnackbar={this.closeSnackbar}
                  messageSnackBar={this.state.action === 'up' ? "Capsule remontée" : "Capsule descendue"} />
              </div>
            </Fade>
            <CreateCapsule />

          </div> :
          <Loading />

        }
      </>
    );
  }
}
const HomePageComponent = withRouter(withFirebase(HomePageComponentBase));

export default HomePage;
export { HomePageComponent };